import { FC } from "react";
import { Button, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import AddIcon from "@mui/icons-material/Add";
import { Link as RouterLink } from "react-router";
import useBasketActions from "../../../Utils/Hooks/useBasketActions";
import { PlayingStatus } from "../../MediaPlayer/ReactPlayerWrapper/playing-statuses";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import { PlayPause } from "../../../Redux/Reducers/redux-slice-react-player";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import useCollectionActions from "../../../Utils/Hooks/useCollectionActions";
import { useTranslation } from "react-i18next";
interface TitleSubbarProps {
  title: string;
  id: number;
}

const TitleSubbar: FC<TitleSubbarProps> = (props) => {
  const { t } = useTranslation();
  const { title, id } = props;
  const { addObjectByIdToBasket } = useBasketActions();
  const { AddItemsToCollection } = useCollectionActions();
  const dispatch = useAppDispatch();

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Button variant="icon" color="neutral" component={RouterLink} to="/">
          <ArrowBackIcon />
        </Button>
        <Typography variant="h5" component="h1" color="text.primary">
          {title}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Button
          startIcon={<PlayingStatus />}
          onClick={() => {
            dispatch(PlayPause());
          }}
        >
          {t("common:mediaPlayer")}
        </Button>
        <Button
          startIcon={<BookmarkBorderOutlinedIcon />}
          onClick={() => AddItemsToCollection([new DbAssetObjectInfos({ id: id, name: title })])}
        >
          {t("button:addToCollection")}
        </Button>
        <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={() => addObjectByIdToBasket(id)}>
          {t("button:addToOrder")}
        </Button>
      </Stack>
    </>
  );
};

export default TitleSubbar;
